<template>
  <TWLoadingSpinner/>
</template>

<script>
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';

export default {
  name: 'RegistrationVerifyEmail',
  components: {
    TWLoadingSpinner,
  },
  async mounted() {
    const { params: { verifyCode } } = this.$route;

    try {
      await this.$store.dispatch('auth/VERIFY_EMAIL', { token: verifyCode });

      this.$bus.$emit('renderGlobalMessage', ({
        message: this.$t('verify.successMessage'),
        icon: 'check',
        type: 'success',
      }));
    } catch {
      this.$bus.$emit('renderGlobalMessage', ({
        message: this.$t('message.fail.verifyEmail'),
        icon: 'times',
        type: 'error',
      }));
    } finally {
      if (this.$store.getters['auth/isAuthenticated']) {
        await this.$router.push({ name: 'Envelopes' });
      } else {
        await this.$router.push({ name: 'Login' });
      }
    }
  },
};
</script>

<style scoped>

</style>
